module.exports = __webpack_public_path__ + "img/fire-flame.ed9b9d7e.svg";